import {
  Card,
  Col,
  DatePicker,
  Form,
  Radio,
  Row,
  Space,
  Tree,
  Typography
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState, useMemo } from "react";
import { validateEndDate } from "../dateValidator";
import { useTranslation } from "react-i18next";

const { Title } = Typography;
const dateFormat = "MM/DD/YYYY";

const Records = ({
  getChildData,
  patientDetailsData,
  form,
  checkedKeys,
  setCheckedKeys,
}) => {
  const { t } = useTranslation();
  const [autoExpandParent, setAutoExpandParent] = useState(false);

  const onChange = (e) => {
    let timeFrameVal =
      e.target.value == 1
        ? "Date Range"
        : e.target.value == 2
          ? "Last 2 years"
          : e.target.value == 3
            ? "All time"
            : "";
    debugger;
    callparent(timeFrameVal, "RecordInformationTimeFrame");
  };
  const onExpand = () => {
    // or, you can remove all expanded children keys.
    setAutoExpandParent(false);
  };
  const onCheck = (checkedKeysValue) => {
    var recordType = "";
    checkedKeysValue.forEach((element) => {
      if (recordType == "") recordType = recordType.concat(element);
      else recordType = recordType.concat(", ".concat(element));
    });
    setCheckedKeys(checkedKeysValue);
    callparent(recordType, "RecordInformationRecordType");
    localStorage.setItem("allrecord", JSON.stringify(checkedKeysValue));
    form.validateFields(["tree"]);
  };

  const callparent = (e, name) => {
    getChildData(e, name);
  };
  const disableFutureDates = (current) => {
    // Can not select days after today
    return current && current > dayjs().endOf("day");
  };
  const disablePastDates = (current) => {
    // Can not select days after today
    return patientDetailsData.RecordInformationStartDate && patientDetailsData.RecordInformationStartDate > current;
  };
  const treeData = [
    {
      title: t("patientDetails:all_records"),
      key: "allrecords",
      className: "all-check",
      children: [
        {
          className: "checkbox-align-width",
          title: t("patientDetails:medical_all"),
          key: "medicalall",
          children: [
            {
              title: t("patientDetails:cardiology_reports"),
              key: "Cardiology Report",
            },
            {
              title: t("patientDetails:consultation_reports"),
              key: "Consultation Reports",
            },
            {
              title: t("patientDetails:continuity_care_document"),
              key: "Continuity Care Document",
            },
            {
              title: t("patientDetails:discharge_summary"),
              key: "Discharge Summary",
            },
            {
              title: t("patientDetails:genetic_test_results"),
              key: "Genetic Test Results",
            },
            {
              title: t("patientDetails:history_and_physical"),
              key: "History and Physical",
            },
            {
              title: t("patientDetails:hospital_er_visits"),
              key: "Hospital/ER Visits",
            },
            {
              title: t("patientDetails:lab_reports"),
              key: "Lab Reports",
            },
            {
              title: t("patientDetails:medications"),
              key: "Medications",
            },
            {
                title: t("patientDetails:operative_reports"),
              key: "Operative Reports",
            },
            {
              title: t("patientDetails:pathology_reports"),
              key: "Pathology Reports",
            },
            {
              title: t("patientDetails:progress_notes"),
              key: "Progress Notes",
            },
            {
              title: t("patientDetails:radiology_reports"),
              key: "Radiology Reports",
            },
            {
              title: t("patientDetails:therapy_notes"),
              key: "Therapy Notes",
            },
            {
              title: t("patientDetails:vaccinations"),
              key: "Vaccinations",
            },
          ],
        },
        {
          className: "checkbox-align-width",
          title: t("patientDetails:billing"),
          key: "Billing",
        },
        {
          className: "checkbox-align-width",
          title: t("patientDetails:radiology_images"),
          key: "Radiology images",
        },
        {
          className: "checkbox-align-width",
          title: t("patientDetails:x_ray_images"),
          key: "X-ray Images",
        },
        {
          className: "checkbox-align-width",
          title: t("patientDetails:ct_scan_images"),
          key: "CT Scan Images",
        },
      ],
    },
  ];

  useEffect(() => {
    form.validateFields(["Tree"]);
  }, [checkedKeys, form]);

  const onTitleClick = (e, node) => {
    e.stopPropagation(); // Prevent event bubbling
    const nodeKey = node.key;
    const isChecked = checkedKeys.includes(nodeKey);
    const newCheckedKeys = isChecked
      ? checkedKeys.filter((key) => key !== nodeKey) // Uncheck if already checked
      : [...checkedKeys, nodeKey]; // Check if not already checked

    setCheckedKeys(newCheckedKeys);
  };

  const validationRules = useMemo(() => ({
    required: [
      { required: true, message: t("patientDetails:please_choose_any_option") }
    ],
    startDate: [
      { required: true, message: t("patientDetails:please_select_the_start_date") }
    ],
    endDate: [
      { required: true, message: t("patientDetails:please_select_the_end_date") },
      { validator: () => validateEndDate(patientDetailsData.RecordInformationStartDate, patientDetailsData.RecordInformationEndDate, t("common:end_date_must_be_greater_than_start_date")) }
    ],
    selectRecord: [
      {
        required: checkedKeys.length == 0 ? true : false,
        message: t("patientDetails:please_select_at_least_one_node")
      }
    ]
  }), [t, checkedKeys.length, patientDetailsData.RecordInformationStartDate, patientDetailsData.RecordInformationEndDate]);

  return (

      <Card
        styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
        bordered={false}
        size="0"
        title={
          <Title
            className="font-semibold"
            style={{ marginBottom: "0" }}
            level={4}
          >
            {t("patientDetails:record_information")}
          </Title>
        }
      >
        <Row gutter={[0, 10]} className="px-1 lg:px-6" align={"bottom"} >
          <Col>
            <Form.Item
              name="timeframerecords"
              label={t("patientDetails:specify_the_timeframe_for_the_records")}
              required
              rules={validationRules.required}
            >
              <Radio.Group onChange={onChange} >
                <Space direction="vertical" className="ms-4"
                >
                  <Radio value={3} className="font-normal">
                    {t("patientDetails:all_time")}
                  </Radio>
                  <Radio value={2} className="font-normal">
                    {t("patientDetails:last_2_years")}
                  </Radio>
                  <Radio value={1} className="font-normal">
                    {t("patientDetails:date_range")}
                  </Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
          {patientDetailsData.RecordInformationTimeFrame.toString() ==
            "Date Range" ? (
            <Col lg={12}>
              <Row gutter={[20, 0]} justify={"start"}>
                <Col span={12} >
                  <Form.Item
                    labelCol={{ xl: 9 }}
                    justify="start"
                    layout="horizontal"
                    name="startdate"
                    label={t("patientDetails:start_date")}
                    required
                    rules={validationRules.startDate}
                  >
                    <DatePicker
                      disabledDate={disableFutureDates}
                      format={dateFormat}
                      style={{ minWidth: "100%" }}
                      onChange={(e) =>
                        callparent(e, "RecordInformationStartDate")
                      }
                      placeholder={t("common:select_date")}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    labelCol={{ xl: 9 }}
                    layout="horizontal"
                    wrapperCol={{
                      xl: 24
                    }}
                    label={t("patientDetails:end_date")}
                    name="enddate"
                    required
                    rules={validationRules.endDate}
                  >
                    <DatePicker
                      disabledDate={disableFutureDates}
                      format={dateFormat}
                      style={{ minWidth: "100%" }}
                      onChange={(e) => callparent(e, "RecordInformationEndDate")}
                      placeholder={t("common:select_date")}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          ) : null}
        </Row>

        <Row gutter={[0, 10]} className="px-6">

          <Col span={24}>
            <Form.Item
              name="selectrecord"
              required
              rules={validationRules.selectRecord}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label={t("patientDetails:what_type_of_records_are_you_requesting")}
            >
              <Tree
                className="px-5 tree-responsive"
                checkable
                onExpand={onExpand}
                autoExpandParent={autoExpandParent}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                treeData={treeData}
                defaultExpandedKeys={["medicalall", "allrecord", "discimages"]}
                titleRender={(node) => (
                  <div onClick={(e) => onTitleClick(e, node)}>{node.title}</div>
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>

  );
};
export default Records;
